module.exports = __webpack_public_path__ + "img/arrow-disabled.d94c4250.svg";